import { CheckCircle2 } from 'lucide-react';

import type { ChecklistSection } from '../funnel-copy';

interface FunnelChecklistCardProps {
  sections: ChecklistSection[];
}

export function FunnelChecklistCard({ sections }: FunnelChecklistCardProps) {
  return (
    <div className="flex flex-col gap-5 rounded-2xl border-1 border-solid border-[#E3DCCE] bg-[#FBFAF7] px-6 py-5">
      {sections.map((section) => (
        <div key={section.heading} className="flex flex-col gap-2">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-500">
            {section.heading}
          </span>
          <ul className="flex flex-col gap-2">
            {section.items.map((item) => (
              <li key={item} className="flex items-start gap-2.5">
                <CheckCircle2
                  className="mt-0.5 h-4 w-4 flex-shrink-0 text-green-600"
                  strokeWidth={2.25}
                  aria-hidden="true"
                />
                <span className="text-sm leading-relaxed text-catch-dark-blue-90">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
